import { Button, Checkbox, CheckboxGroup, Stack, Switch, Text } from '@chakra-ui/react';
import { CargoType } from '@pelicargo/types';
import { allCargoTypeOptions } from '@pelicargo/utils';
import { useCallback, useMemo } from 'react';
import { HiChevronLeft } from 'react-icons/hi';

import { RequestFilters } from '../../hooks/useRequestFilters';

type Props = {
  filters: RequestFilters;
  handleCheckboxFilterChange: (key: string) => (nextValue: string[]) => void;
  resetView: () => void;
};

export const CargoTypeFilter = ({ filters, handleCheckboxFilterChange, resetView }: Props) => {
  const cargoTypes = Object.values(CargoType);

  const localOnChange = useCallback(
    (nextValue: string[]) => {
      handleCheckboxFilterChange('cargo_type')(nextValue);
    },
    [handleCheckboxFilterChange],
  );

  const handleToggleAll = () => {
    if (filters.cargo_type.length === cargoTypes?.length) {
      handleCheckboxFilterChange('cargo_type')([]);
    } else {
      handleCheckboxFilterChange('cargo_type')(cargoTypes);
    }
  };

  const cargoTypeOptions = useMemo(() => allCargoTypeOptions.filter((n) => n?.value !== CargoType.Batteries), []);

  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
          Cargo Type
        </Button>
      </Stack>
      <Stack direction="row" align="center" justify="space-between" w="full">
        <Text>Select all</Text>
        <Switch size="sm" isChecked={filters.cargo_type.length === cargoTypes?.length} onChange={handleToggleAll} />
      </Stack>
      <Stack>
        <CheckboxGroup value={filters.cargo_type} onChange={localOnChange}>
          {cargoTypeOptions?.map((node) => (
            <Checkbox key={node.value} value={node.value}>
              {node.label}
            </Checkbox>
          ))}
        </CheckboxGroup>
      </Stack>
    </Stack>
  );
};
